module.exports = __webpack_public_path__ + "img/payment5.99908d4c.png";